<template>
  <v-dialog v-model="dialog" width="500" height="900" scrollable>
    <template v-slot:activator="{ on }">
      <!-- botao de selecionar professores -->
      <v-col sm="12">
        <div class="botao-selecionar-professor" v-on="on">
          <template v-if="selectedProfessor">
            <span>Vendo horários disponíveis de</span><br />
            {{ selectedProfessor.name }}
            <v-icon color="#FFFFFF">mdi-chevron-down</v-icon><br />
            <span>clique para alterar</span>
          </template>
          <template v-else>
            <span>Vendo horários disponíveis de</span><br />
            Todos os professores
            <v-icon color="#FFFFFF">mdi-chevron-down</v-icon><br />
            <span>clique para alterar</span>
          </template>
        </div>
      </v-col>
    </template>

    <!-- dialog de selecionar professores -->
    <v-card>
      <v-card-title class="headline-dialog text-center">
        Selecione<br />
        um professor
      </v-card-title>

      <v-card-text style="height: 300px;">
        <div
          v-for="professor in professorsBySubject"
          :key="professor.name"
          class="teachers-dialog-item"
          @click="onSelectProfessors(professor)"
        >
          <div class="teacher-photo">
            <img
              width="100%"
              :src="professor.image ? professor.image : '/img/fav_icon2.png'"
              alt=""
              class="img-teacher-foto"
            />
          </div>
          <div class="teacher-name">
            {{ professor.name }}
            <v-rating v-if="professor.rating" size="18" background-color="rgba(68, 0, 153,0.2)" color="rgba(68, 0, 153,0.8)" dense :value="professor.rating" readonly empty-icon="mdi-star" full-icon="mdi-star" half-increments></v-rating>
          </div>
        </div>
      </v-card-text>

      <v-card-actions>
        <v-btn
          class="mt-5 mb-5 ml-5 mr-5"
          color="grey darken-1"
          rounded
          outlined
          @click="dialog = false"
        >
          Fechar
        </v-btn>
        <div class="spacer" />
        <v-btn
          class="mt-5 mb-5 ml-5 mr-5"
          color="grey darken-1"
          rounded
          outlined
          @click="showAll"
        >
          Selec. todos
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapState, mapMutations } from "vuex";
import UserRepository from "@/repositories/UserRepository";

export default {
  props: {
    subjectId: [String, Number]
  },
  data() {
    return {
      professor: undefined,
      dialog: false
    };
  },
  computed: {
    ...mapGetters("professorsModule", ["professorsBySubject", "freeTimeIds"]),
    ...mapState("professorsModule", [
      "freeTimes",
      "professors",
      "selectedProfessor"
    ])
  },
  methods: {
    ...mapMutations("professorsModule", ["setSelectedProfessor"]),
    onSelectProfessors(professor) {
      this.dialog = false;
      this.setSelectedProfessor(professor);
    },
    showAll() {
      this.setSelectedProfessor(undefined);
      this.dialog = false;
    }
  }
};
</script>

<style>
/* @import url("https://fonts.googleapis.com/css?family=Montserrat:700,900&display=swap"); */

html {
  /* font-family: "Montserrat", sans-serif; */
  font-family: 'Poppins', sans-serif;
}
.v-card__title.headline-dialog,
.v-dialog > .v-card > .v-card__title {
  /* font-family: "Montserrat", sans-serif; */
  font-family: 'Poppins', sans-serif;
  color: #440099;
  font-size: 21px;
  font-weight: 700;
  text-transform: uppercase;
  padding: 32px 24px 46px;
  margin: 0 auto;
  line-height: 1.3;
}
.teachers-dialog-item {
  display: table;
  width: 100%;
  padding: 6px 12px;
  background-color: rgba(255, 255, 255, 1);
  border: 1px solid #eeeeee;
  position: relative;
  cursor: pointer;
}
.teachers-dialog-item:hover {
  background-color: rgba(252, 252, 252, 1);
}
.teachers-dialog-item:active {
  background-color: #44ff99;
  cursor: wait;
}
.botao-selecionar-professor {
  padding: 16px;
  margin: 16px;
  display: block;
  border: 2px solid #ffffff;
  box-shadow: 0 2px 5px 1px rgba(20, 10, 30, 0.5);
  text-align: center;
  font-weight: 700;
  /* font-family: "Montserrat", sans-serif; */
  font-family: 'Poppins', sans-serif;
  color: #ffffff;
  font-size: 16px;
  line-height: 1.3;
  cursor: pointer;
  transition: 0.1s;
}
.botao-selecionar-professor:hover {
  background-color: rgba(255, 255, 255, 0.1);
  box-shadow: 0 8px 13px 1px rgba(20, 10, 30, 0.3);
}
.botao-selecionar-professor:active {
  background-color: rgba(0, 0, 0, 0.1);
  box-shadow: 0 0 1px 1px rgba(20, 10, 30, 0.6);
  transform: scale(0.98);
  transition: 0.1s ease-out;
}
.botao-selecionar-professor span {
  font-weight: 200;
  font-size: 11px;
  /* font-style: italic; */
}
.teacher-photo {
  display: flex;
  background-image: url("/assets_aluno/galileo_3.jpg");
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
  border-radius: 999px;
  height: 64px;
  width: 64px;
  border: 1px solid #eeeeee;
}
.img-teacher-foto{
  object-fit: cover;
  border-radius: 999px;
  border: 2px solid rgba(255,255,255,1);
  box-shadow: 0px 2px 6px rgba(29, 10, 53, 0.4);
}
.teacher-name {
  display: table-cell;
  vertical-align: middle;
  font-size: 18px;
  font-weight: 700;
  padding-left: 16px;
  color: #440099;
  width: 100%;
  text-align: left;
}
</style>
